if (!customElements.get('product-info-tabs')) {
  customElements.define(
    'product-info-tabs',
    class ProductInfoTabs extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));

        if (!this.tabs.length || !this.panels.length) return;

        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.activateTab(tab));
          tab.addEventListener('keydown', (event) => this.handleKeydown(event, index));
        });
      }

      activateTab(activeTab, moveFocus = false) {
        this.tabs.forEach((tab) => {
          const isActive = tab === activeTab;
          tab.setAttribute('aria-selected', String(isActive));
          tab.tabIndex = isActive ? 0 : -1;
        });

        this.panels.forEach((panel) => {
          panel.hidden = panel.id !== activeTab.getAttribute('aria-controls');
        });

        if (moveFocus) activeTab.focus();
      }

      handleKeydown(event, currentIndex) {
        let nextIndex;

        switch (event.key) {
          case 'ArrowRight':
            nextIndex = (currentIndex + 1) % this.tabs.length;
            break;
          case 'ArrowLeft':
            nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
            break;
          case 'Home':
            nextIndex = 0;
            break;
          case 'End':
            nextIndex = this.tabs.length - 1;
            break;
          default:
            return;
        }

        event.preventDefault();
        this.activateTab(this.tabs[nextIndex], true);
      }
    }
  );
}
